module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('doc-section', {
    attrs: {
      "id": "progressbar",
      "name": "Progressbar"
    }
  }, [_c('div', {
    staticClass: "bs-example"
  }, [_c('h4', [_vm._v("Static")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "progress"
  }, [_c('progressbar', {
    attrs: {
      "now": "20",
      "type": "success"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "progress"
  }, [_c('progressbar', {
    attrs: {
      "now": "40",
      "type": "info"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "progress"
  }, [_c('progressbar', {
    attrs: {
      "now": "60",
      "type": "primary"
    }
  })], 1)])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h4', [_vm._v("Dynamic "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.dynamicClick
    }
  }, [_vm._v("Randomize")])]), _vm._v(" "), _c('div', {
    staticClass: "progress"
  }, [_c('progressbar', {
    attrs: {
      "now": _vm.dynamicData[0],
      "type": "info"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "progress"
  }, [_c('progressbar', {
    attrs: {
      "now": _vm.dynamicData[1],
      "type": "warning"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "progress"
  }, [_c('progressbar', {
    attrs: {
      "now": _vm.dynamicData[2],
      "type": "danger"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "progress"
  }, [_c('progressbar', {
    attrs: {
      "now": _vm.dynamicData[3],
      "type": "success",
      "striped": ""
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "progress"
  }, [_c('progressbar', {
    attrs: {
      "now": _vm.dynamicData[4],
      "type": "success",
      "striped": "",
      "animated": ""
    }
  })], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h4', [_vm._v("Stacked "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.stackedClick
    }
  }, [_vm._v("Randomize")])]), _vm._v(" "), _c('div', {
    staticClass: "progress"
  }, [_c('progressbar', {
    attrs: {
      "now": _vm.stackedData[0],
      "label": "",
      "type": "warning",
      "striped": ""
    }
  }), _vm._v(" "), _c('progressbar', {
    attrs: {
      "now": _vm.stackedData[1],
      "label": "",
      "type": "success"
    }
  }), _vm._v(" "), _c('progressbar', {
    attrs: {
      "now": _vm.stackedData[2],
      "label": "",
      "type": "danger"
    }
  }), _vm._v(" "), _c('progressbar', {
    attrs: {
      "now": _vm.stackedData[3],
      "label": "",
      "type": "primary",
      "striped": "",
      "animated": ""
    }
  })], 1)]), _vm._v(" "), _c('doc-code', {
    attrs: {
      "language": "markup"
    }
  }, [_vm._v("\n    <!-- Single -->\n    <div class=\"progress\">\n      <progressbar now=\"\" label type=\"warning\" striped></progressbar>\n    </div>\n    <!-- Stacked -->\n    <div class=\"progress\">\n      <progressbar now=\"...\" label type=\"warning\" striped></progressbar>\n      <progressbar now=\"...\" label type=\"success\"></progressbar>\n      <progressbar now=\"...\" label type=\"danger\"></progressbar>\n      <progressbar now=\"...\" label type=\"primary\" striped animated></progressbar>\n    </div>\n  ")]), _vm._v(" "), _c('doc-table', [_c('div', [_c('p', [_vm._v("now")]), _vm._v(" "), _c('p', [_c('code', [_vm._v("Number")])]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', [_vm._v("The current value of progress completed. Required.")])]), _vm._v(" "), _c('div', [_c('p', [_vm._v("type")]), _vm._v(" "), _c('p', [_c('code', [_vm._v("String")])]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', [_vm._v("Style type. Possible values are 'success', 'warning' etc.")])]), _vm._v(" "), _c('div', [_c('p', [_vm._v("label")]), _vm._v(" "), _c('p', [_c('code', [_vm._v("Boolean")])]), _vm._v(" "), _c('p', [_vm._v("false")]), _vm._v(" "), _c('p', [_vm._v("Whether to show the label.")])]), _vm._v(" "), _c('div', [_c('p', [_vm._v("striped")]), _vm._v(" "), _c('p', [_c('code', [_vm._v("Boolean")])]), _vm._v(" "), _c('p', [_c('code', [_vm._v("false")])]), _vm._v(" "), _c('p', [_vm._v("Whether the progressbar has striped effect or not.")])])])], 1)
},staticRenderFns: []}
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4b38aabc", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4b38aabc!./~/vue-loader/lib/selector.js?type=template&index=0!./docs/example/progressbarDocs.vue
// module id = 247
// module chunks = 0